<template>
  <div class="rules">
    <h4 class="headtitle">{{$t('Download')}}:</h4>

    <div class="boxs" v-for="item in resourceList" :key="item.id">
      <div class="download">
        <div class="left">
          <div class="title">{{ item.dataName }}</div>
          <div class="times">{{ item.updateDate }}</div>
        </div>
        <div class="right" @click="download(item.dataRoute, item.dataName)">
          <img src="../assets/28752x.png" />
          <span>下载</span>
        </div>
      </div>
      <div class="download-border"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resourceList: [],
    };
  },
  created() {
    this.$getHttp("pc/tDataDownload/findAllDataDownload").then((res) => {
      if (res.success) {
        res.DataDownload.map((v) => {
          v.dataRoute = v.dataRoute;
        });
        this.resourceList = res.DataDownload;
      } else {
        this.$message({
          message: res.msg,
        });
      }
    });
  },
  methods: {
    download(url, fileName) {
      // console.log(url, "url");
      // window.open(url, "_self");
      // return;
      // this.$download({
      //   url,
      // }).then((res) => {
      //   res.blob().then((blob) => {
      //     const blobUrl = window.URL.createObjectURL(blob);
      //     // 这里的文件名根据实际情况从响应头或者url里获取
      //     const filename = fileName;
      //     const a = document.createElement("a");
      //     a.href = blobUrl;
      //     a.download = filename;
      //     a.click();
      //     window.URL.revokeObjectURL(blobUrl);
      //   });
      // });

      // return;
      // this.$imgUrl + 
      console.log(url);
      //  this.dd(this.$imgUrl + url,fileName+item.substr(item.lastIndexOf('.')))
      // return
      if(url.indexOf('|')>-1){
        url.split("|").map((item,index)=>{
          
          
             this.dd(this.$imgUrl + item,fileName+`(${index+1})`+item.substr(item.lastIndexOf('.')))
        })
      }else{
        this.dd(this.$imgUrl + url,fileName+url.substr(url.lastIndexOf('.')))
      }
      
    },
    dd(url,fileName){
      fetch(url).then((res) => {
        console.log(res);
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = fileName;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  },
};
</script>

<style lang="less">
.rules {
  text-align: left;
  .headtitle {
    position: relative;
    font-size: 26px;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #333333;
    font-weight: 500;
    padding-left: 20px;
    margin-left: 5px;
    margin-top: 6px;
    margin-bottom: 25px;
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 24px;
      background: #6f73f4;
      border-radius: 2px 2px 2px 2px;
    }
  }
  .boxs {
    .download {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        .title {
          height: 28px;
          font-size: 20px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 38px;
        }
        .times {
          height: 25px;
          font-size: 18px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 38px;
          margin-top: 6px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 30px;
          height: 30px;
        }
        span {
          font-size: 22px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .download-border {
      height: 1px;
      background: #d0d0d0;
      margin-top: 30px;
    }
  }
}
</style>